'use client'

import { TPropsWithChildren } from '@ftd/types'
import { NextIntlClientProvider } from 'next-intl'
import { AbstractIntlMessages } from 'next-intl'
import { NuqsAdapter } from 'nuqs/adapters/next/app'

import { TLocales } from '@/i18n/types'
import { MantineProvider } from '@/styles/MantineProvider'

import { QueryProvider } from './QueryProvider'

type TProps = {
  messages: AbstractIntlMessages
  locale: TLocales
}

export const Providers: TPropsWithChildren<TProps> = ({ children, locale, messages }) => (
  <NextIntlClientProvider locale={locale} messages={messages} timeZone="Europe/Bratislava">
    <NuqsAdapter>
      <QueryProvider>
        <MantineProvider>{children}</MantineProvider>
      </QueryProvider>
    </NuqsAdapter>
  </NextIntlClientProvider>
)
